<!--
 * @Description: 不通过
 * @Date: 2021-06-28 18:44:27
-->
<template>
  <BaseDialog
    title="审核不通过"
    width="800px"
    :model-value="true"
    :before-close="props.remove"
    :close-on-press-escape="true"
  >
    <div class="reject">
      <div class="reject__content">
        <div class="text-area">
          <BaseInput
            style="width: 400px"
            type="textarea"
            :autosize="{
              minRows: 9
            }"
            :maxlength="200"
            :show-word-limit="true"
            placeholder="请输入批注(您可以点击下方内容进行快捷回复)"
            v-model.trim="textarea"
          ></BaseInput>
        </div>
        <div class="select-area" style="overflow-y: scroll">
          <ol>
            <li>
              <h2>请选择快捷批注内容</h2>
            </li>
            <li
              class="select-text"
              v-for="(item, index) in textArray"
              :key="index"
              @click="textarea += item.content"
            >
              <span>{{ index + 1 }}.{{ item.content }}</span>
              <BaseButton
                v-if="item.id"
                size="small"
                type="text"
                plain
                @click.stop="removeItem(item.id)"
                style="color: red; width: 50px"
              >
                ✖
              </BaseButton>
            </li>
          </ol>
        </div>
      </div>
    </div>
    <template #footer>
      <div class="footer">
        <div>
          <BaseButton @click="confirm(1)" type="primary" plain>
            提交并加入快捷回复
          </BaseButton>
          <BaseButton @click="confirm(0)" type="primary" plain>
            仅提交
          </BaseButton>
          <BaseButton @click="props.remove" type="default">关闭</BaseButton>
        </div>
      </div>
    </template>
  </BaseDialog>
</template>

<script lang="tsx" setup>
import { withDefaults, defineProps, defineEmits, ref, onMounted } from 'vue';
import {
  BaseDialog,
  BaseButton,
  BaseInput,
  XrkMessage,
  XrkMessageBox
} from 'xrk-components';
import { quickReplyList, deleteQuickReply } from '../data-source/apis';
const props = withDefaults(
  defineProps<{
    projectId: string | number;
    remove?: () => void;
  }>(),
  {}
);
const textarea = ref('');
const emits = defineEmits(['confirm']);

const textDefault = [];

const textArray = ref([]);

const removeItem = async id => {
  await XrkMessageBox.confirm('是否删除快捷回复');
  await deleteQuickReply({ id });
  await getList();
};

const confirm = async remarkType => {
  if (!textarea.value) {
    XrkMessage.error('请输入不通过原因');
    return;
  }
  if (textarea.value.length > 200) {
    XrkMessage.error('不通过原因不可超过200字');
    return;
  }
  await XrkMessageBox.confirm('是否确认提交');
  emits('confirm', { remarkType, remarks: textarea.value });
  XrkMessage.success('提交成功');
  props.remove();
};

const getList = async () => {
  const { data } = await quickReplyList({ projectId: props.projectId });
  if (!data) {
    textArray.value = textDefault;
    return;
  }
  textArray.value = [...textDefault, ...data];
};

onMounted(async () => {
  getList();
});
</script>
<style lang="scss" scoped>
.reject {
  width: 700px;
  margin: 20px auto;

  &__content {
    display: flex;
    align-items: center;
    justify-content: space-around;
  }
}
.select-area {
  text-align: left;
  .select-text {
    margin-top: 23px;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #888888;
    display: flex;
    justify-content: space-between;
  }
  .select-text:hover {
    background-color: #fff;
    cursor: pointer;
  }
  width: 280px;
  padding: 20px;
  height: 199px;
  background: #f5f7fa;
  border-radius: 2px;
  opacity: 0.99;
}
.footer {
  display: flex;
  justify-content: space-between;
  text-align: right;
  margin-top: 30px;
}
</style>
